<template>
    <div>
        <header v-if="title" class="mb-6">
            <h2 class="text-lg leading-6 font-medium text-gray-900">
                <slot name="title">{{ title }}</slot>
            </h2>
            <p class="mt-1 text-sm text-gray-500">
                <slot name="subtitle">{{ subtitle }}</slot>
            </p>
        </header>
        <div class="grid" :class="grid">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
        subtitle: String,
        grid: {
            type: String,
            default: 'gap-6 grid-cols-12'
        }
    }
}
</script>
